import { createSelector } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TLearningCurveState } from './learning-curve.models';

export const getLearningCurveState = (state: TPlani8State) => state.learningCurvesInfo;

export const GetLearningCurveInfo = createSelector(
  getLearningCurveState,
  (state: TLearningCurveState) => state.learningCurveInfo,
);

export const GetUserPaginationOption = createSelector(
  getLearningCurveState,
  (state: TLearningCurveState) => state.userPaginationOption,
);
